import theme from '@styles/theme';
import Icon from '@components/icons/Icon';
import styles from './MissingPicturePlaceholder.styles';
const MissingPicturePlaceholder = () => <div sx={styles.container}>
    <Icon icon="EmptyPicture" size="442px" color={theme.rawColors.lightGrey700} addSx={styles.icon} />
  </div>;
export default MissingPicturePlaceholder;